/**
 * @generated SignedSource<<fc0ca92fd9bf677a0b72db2222d110dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentArticleAtomBase$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"abandonedCartOfferDialogArticle" | "articleHeadlineHeaderFeaturesContent" | "articleSeoArticle" | "articleShareWidgetArticle" | "bookmarkHeaderFeaturesContent" | "commentHeaderFeaturesArticle" | "contentShareWidgetContent" | "entityLinkHeaderFeaturesArticle" | "helpersCheckIsStyleArticle" | "helpersUseSharingUrl" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle" | "hooksUseCurrentArticleIdsArticle" | "hooksUseCurrentArticlePrebidConfigArticle" | "hooksUsePageTargetingArticle" | "onboardingNewsletterSubscriptionArticle" | "shareHeaderFeaturesContent">;
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
};
export type atomsCurrentArticleAtomBase$key = {
  readonly " $data"?: atomsCurrentArticleAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentArticleAtomBase"
};

(node as any).hash = "5d3ab2a0bca725d5857a9c4d5a1be72f";

export default node;
